import {CatalogService} from "@/services/ModelRisk/CatalogService";
import {MsScoreCatalogRepository} from "@/services/ModelRisk/MsScoreCatalogRepository";
import {AdminContext} from "@/services/ModelRisk/Admin/AdminContext";
import {ApproveRiskModelService} from "@/services/ModelRisk/ApproveModelRisk/ApproveRiskModelService";
import {PreApproveRiskModel} from "@/services/ModelRisk/PreApproveRiskModel/PreApproveRiskModel";
import {SupplierRiskModel} from "@/services/ModelRisk/SupplierRiskModel/SupplierRiskModel";

export class RiskModel {
    static endpoint = `${process.env.VUE_APP_RISK_MODEL_ENDPOINT}/risk-model`

    static catalog() { return new CatalogService(new MsScoreCatalogRepository()); }
    static admin() { return new AdminContext(); }
    static approve() { return new ApproveRiskModelService(); }
    static preApprove() { return new PreApproveRiskModel(); }
    static supplier() { return new SupplierRiskModel(); }
}
